import { jsx } from "react/jsx-runtime";
import { Drawer } from "@perxis-auto/ui-kit/lib";
import clsx from "clsx";
import styles from "./Wrapper.module.scss.js";
function Wrapper({
  title,
  isMobile,
  isVisible,
  className,
  onToggle,
  asideRef,
  asideHeight,
  children
}) {
  if (!isVisible) {
    return null;
  }
  if (!isMobile) {
    return /* @__PURE__ */ jsx("aside", { ref: asideRef, className: clsx(styles.wrapper, className), style: { height: asideHeight || "auto" }, children });
  }
  return /* @__PURE__ */ jsx("aside", { ref: asideRef, className: clsx(styles.wrapper, className), style: { height: asideHeight || "auto" }, children: /* @__PURE__ */ jsx(Drawer, { open: true, title, placement: "left", onClose: onToggle, rootClassName: styles.wrapper_drawer, children }) });
}
export {
  Wrapper
};
